/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeatLoadByEnergyCertRequestPost } from '../../models/heat-load-by-energy-cert-request-post';
import { HeatLoadByEnergyCertResponse } from '../../models/heat-load-by-energy-cert-response';

export interface CalculationsControllerEnergyCertificate$Params {
      body: HeatLoadByEnergyCertRequestPost
}

export function calculationsControllerEnergyCertificate(http: HttpClient, rootUrl: string, params: CalculationsControllerEnergyCertificate$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByEnergyCertResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerEnergyCertificate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeatLoadByEnergyCertResponse>;
    })
  );
}

calculationsControllerEnergyCertificate.PATH = '/planning-projects/v1-preview/calculations/heat-load/energy-certificate';
